function Shimmer() {
  return (
    <div data-store-shimmer>
      <div data-shimmer />
    </div>
  )
}

export default Shimmer
